import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const FaqApi = createApi({
  reducerPath: "FaqApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + "faq",
    // prepareHeaders : (headers) => {
    //     headers.set("Content_Type" , "application/json")
    //     return headers ;
    // }
  }),
  endpoints: (builder) => ({
    getFaq: builder.query({
      query: () => ({
        url: "",
        method : "GET"
      }),
    }),
  }),
});
export const { useGetFaqQuery } = FaqApi